import { querySelectArray } from './utils';

const InitSearchBoxes = () => {
    const searchboxes = querySelectArray('[data-searchbox-ref]', document);
    searchboxes.forEach(InitSearchBox);
};

const InitSearchBox = searchBox => {
    // Restore form state from 'q' param
    const loc = window.location.toString();
    const queryIndexOf = loc.indexOf('?');
    if (queryIndexOf === -1) return;
    const query = loc.substring(queryIndexOf);
    const params = new window.URLSearchParams(query);
    const q = params.get('q');
    searchBox.value = q;
};

export default InitSearchBoxes;
